<template>
	<div
		class="g-block-body-basic g-block-body-padding"
		:class="{
			'g-block-body-basic--edit': editable,
			'is-active': editable && active,
			'g-block-body-basic--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<RichTextEditable
			v-if="editable"
			class="g-block-body-basic__text"
			:model-value="data.content"
			placeholder=""
			@update:model-value="onContentUpdate"
			@focus="onWrapClick"
		/>
		<div
			v-else-if="data.content && data.content.length > 0"
			class="g-block-body-basic__text"
			v-html="data.content"
		></div>
		<div
			v-else
			class="g-block-body-basic__text"
		>&nbsp;</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { bodyMixin } from '../shared/bodyMixin.js';

	export default {
		name: 'GBlockBodyBasic',
		components: { RichTextEditable },
		mixins: [bodyMixin],
		computed: {

		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-basic {
		.body-block-edit-shell();
	}

	.g-block-body-basic__text {
		.body-text-base();

		&--placeholder {
			color: #d9d9d9;
		}
	}

	.g-block-body-basic--h5 {
		.body-text-base--h5(~'.g-block-body-basic__text');
	}
</style>
